import React from 'react';

interface SplitFlightNumberInputProps {
  flightNumberPrefix: string;
  flightNumberDigits: string;
  onPrefixChange: (value: string) => void;
  onDigitsChange: (value: string) => void;
  onBlur: () => void;
  error?: string | null;
  disabled?: boolean;
}

/**
 * Split Flight Number Input Component
 * Two separate editable inputs: prefix (e.g., "AK", "D7") + digits (e.g., "1234")
 */
export function SplitFlightNumberInput({
  flightNumberPrefix,
  flightNumberDigits,
  onPrefixChange,
  onDigitsChange,
  onBlur,
  error,
  disabled,
}: SplitFlightNumberInputProps) {
  const hasError = error && error.trim() !== '';

  return (
    <div className="block mb-2">
      <label className="block mb-1.5 text-base font-semibold text-gray-600">
        Flight Number
        <span className="text-danger-500 ml-1">*</span>
      </label>
      <div className="flex gap-2 items-start">
        {/* Flight number prefix - editable (e.g., AK, D7, MH) */}
        <input
          type="text"
          value={flightNumberPrefix || ''}
          onChange={e => onPrefixChange(e.target.value.toUpperCase())}
          onBlur={onBlur}
          maxLength={3}
          disabled={disabled}
          className={`w-20 px-3 py-2.5 border rounded-lg text-gray-900 text-lg outline-none transition-all font-mono text-center
            ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'}
            ${hasError
              ? 'border-danger-500 focus:border-danger-500 focus:ring-3 focus:ring-danger-500/10'
              : 'border-gray-300 focus:border-primary-500 focus:ring-3 focus:ring-primary-500/10'
            }`}
        />

        {/* Flight number digits - editable (e.g., 1234) */}
        <div className="flex-1">
          <input
            type="text"
            value={flightNumberDigits}
            onChange={e => onDigitsChange(e.target.value)}
            onBlur={onBlur}
            maxLength={4}
            disabled={disabled}
            placeholder="1234"
            className={`w-full px-3 py-2.5 border rounded-lg text-gray-900 text-lg outline-none transition-all font-mono
              ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'}
              ${hasError
                ? 'border-danger-500 focus:border-danger-500 focus:ring-3 focus:ring-danger-500/10'
                : 'border-gray-300 focus:border-primary-500 focus:ring-3 focus:ring-primary-500/10'
              }`}
          />
        </div>
      </div>
    </div>
  );
}
